// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Navbar_wrapper__2ZSHe","container":"Navbar_container__1rTtc","logo":"Navbar_logo__1lP5M","link":"Navbar_link__2hVFQ","active":"Navbar_active__tSSjl"};